import LayoutWithoutNavFooter from '@/components/layouts/LayoutWithoutNavFooter'

export default [
  {
    path: '/map',
    navbar: false,
    title: 'map',
    icon: 'ion ion-md-maps',
    component: LayoutWithoutNavFooter,
    meta: { 'perm': 'Navbar.Map' },
    children: [ {
      path: '',
      title: 'map',
      icon: 'ion ion-md-settings',
      name: 'map',
      component: () => import('@/pages/Map/MapBoxMap')
    }]
  },
  {
    path: '/batch-tracking',
    navbar: true,
    title: 'batch_tracking',
    icon: 'fas fa-map-marked',
    component: LayoutWithoutNavFooter,
    meta: { 'perm': 'Navbar.Map' },
    children: [ {
      path: '',
      title: 'batch_tracking',
      icon: 'fas fa-map-marked',
      name: 'batch_tracking',
      component: () => import('@/pages/Map/BatchTracking')
    }]
  },
  {
    path: '/history-tracking',
    navbar: true,
    title: 'history_tracking',
    icon: 'fas fa-car',
    component: LayoutWithoutNavFooter,
    meta: { 'perm': 'Navbar.HistoryTracking' },
    children: [ {
      path: '',
      title: 'history_tracking',
      icon: 'ion ion-md-settings',
      name: 'history_tracking',
      component: () => import('@/pages/HistoryTracking/HistoryTracking')
    }]
  },
  {
    path: '/history-batch-tracking',
    navbar: true,
    title: 'history_batch_tracking',
    icon: 'fas fa-road',
    component: LayoutWithoutNavFooter,
    meta: { 'perm': 'Navbar.Map' },
    children: [ {
      path: '',
      title: 'history_batch_tracking',
      icon: 'fas fa-road',
      name: 'history_batch_tracking',
      component: () => import('@/pages/Map/HistoryBatchTracking')
    }]
  }
]
